// Conteúdo real da Cãopanhia Pet — fonte única para todas as seções.

export const WHATSAPP_NUMBER = '5543998228311';
export const WHATSAPP_DISPLAY = '(43) 99822-8311';
export const INSTAGRAM_URL = 'https://www.instagram.com/caopanhia_pet.oficial/';
export const INSTAGRAM_HANDLE = '@caopanhia_pet.oficial';
export const LOCATION = 'Jardim Alegre - PR';
export const HOURS = 'Atendimentos nos finais de semana';
export const LOGO = '/images/brand/logo.jpg';

export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

export const DEFAULT_MESSAGE =
  'Olá! Vim pelo site Cãopanhia Pet e gostaria de mais informações sobre os serviços para pets! 🐾';

// Fotos locais (geradas em /public/images/pets em dois tamanhos: -sm e -lg)
const photo = (name, alt, [wSm, wLg]) => ({
  name,
  alt,
  sm: `/images/pets/${name}-sm.webp`,
  lg: `/images/pets/${name}-lg.webp`,
  srcSet: `/images/pets/${name}-sm.webp ${wSm}w, /images/pets/${name}-lg.webp ${wLg}w`,
});

export const PHOTOS = {
  oculosCloseup: photo('oculos-closeup', 'Cachorro de óculos escuros espelhados sorrindo para a câmera', [580, 832]),
  oculosEmPe: photo('oculos-em-pe', 'Cachorro de óculos escuros em pé nas patinhas de trás, de língua de fora', [436, 704]),
  salaDeBanho: photo('sala-de-banho', 'Cachorrinho sorrindo com gravata listrada na sala de banho, com banheira de inox e toalhas', [661, 896]),
  yorkshireFofo: photo('yorkshire-fofo', 'Yorkshire com presilha rosa e gravatinha azul de bolinhas', [615, 1200]),
  yorkshireLingua: photo('yorkshire-lingua', 'Yorkshire lambendo o focinho, com presilha rosa', [615, 1200]),
  posBanho: photo('pos-banho', 'Cachorro branco peludo de olhos azuis, pós-banho, com lacinho dourado e bandana', [820, 1080]),
  gatoLaranja: photo('gato-laranja', 'Gato laranja de olhos verdes olhando pela janela', [820, 1080]),
  grama: photo('grama', 'Cachorro de pelo longo deitado na grama, de língua de fora', [786, 787]),
  siames: photo('siames', 'Gato siamês de olhos azuis', [615, 1200]),
  passeioNoite: photo('passeio-noite', 'Rottweiler feliz deitado na grama em um passeio noturno à beira do lago', [615, 1200]),
  lacoRosa: photo('laco-rosa', 'Cachorro de pelo longo com laço rosa na cabeça, de língua de fora', [615, 1200]),
  noColo: photo('no-colo', 'Cachorrinho com bandana de morangos no colo de uma pessoa', [547, 1067]),
  // fotos do salão (parede de tijolinho, madeira ripada e luz âmbar)
  salaoPastor: photo('salao-pastor', 'Pastor de pelo longo com lacinhos rosa e bandana vermelha, sentado na mesa do salão', [615, 1086]),
  salaoLacoVermelho: photo('salao-laco-vermelho', 'Cachorro de pelo longo com topete preso e laço vermelho brilhante, deitado na mesa do salão', [615, 1086]),
  salaoLacoLilas: photo('salao-laco-lilas', 'Cachorrinho de pelo longo com duas maria-chiquinhas de laço lilás, deitado na mesa do salão', [615, 1086]),
  salaoDeitado: photo('salao-deitado', 'Cachorrinho branco e caramelo deitado no chão de madeira do salão', [615, 1086]),
  salaoLambendo: photo('salao-lambendo', 'Cachorrinho branco e caramelo lambendo o focinho, sentado no salão', [615, 1086]),
  passeioBolinha: photo('passeio-bolinha', 'Rottweiler feliz deitado na grama com uma bolinha amarela e a guia', [461, 900]),
  lana: photo('lana', 'Lana, husky de pelagem ruiva e branca e olhos de cores diferentes, com lacinhos rosa e bandana rosa', [614, 1085]),
  arraia: photo('arraia', 'Cachorro branco de olhos azuis com bandana xadrez azul em cenário de festa junina', [615, 1086]),
};

export const NAV_ITEMS = [
  { id: 'inicio', label: 'Início' },
  { id: 'banho', label: 'Banho' },
  { id: 'passeio', label: 'Passeio' },
  { id: 'galeria', label: 'Galeria' },
  { id: 'faq', label: 'Dúvidas' },
  { id: 'contato', label: 'Contato' },
];

// Ilustrações das etapas do banho — mesmo estilo e personagens do logo
// `pos`: enquadramento quando o quadro fica quase quadrado (celular) — mantém as cabeças inteiras
const illustration = (name, alt, pos = '50% 20%') => ({
  name,
  alt,
  pos,
  lg: `/images/ilustracoes/${name}-lg.webp`,
  srcSet: `/images/ilustracoes/${name}-sm.webp 640w, /images/ilustracoes/${name}-lg.webp 1024w`,
});

// O que está incluso no banho (texto do FAQ original)
export const BATH_STEPS = [
  {
    n: '01',
    title: 'Banho',
    text: 'Produtos hipoalergênicos, com calma e cuidado do começo ao fim.',
    art: illustration('banho', 'Ilustração do husky do logo tomando banho de espuma na banheira'),
  },
  {
    n: '02',
    title: 'Secagem',
    text: 'Toalha e secagem completa, até o último pelinho.',
    art: illustration('secagem', 'Ilustração do rottweiler do logo enrolado na toalha, com secador'),
  },
  {
    n: '03',
    title: 'Escovação',
    text: 'Escovação dos pelos para deixar tudo macio e fofinho.',
    art: illustration('escovacao', 'Ilustração do husky do logo sendo escovado, com o pelo fofinho'),
  },
  {
    n: '04',
    title: 'Perfume',
    text: 'O toque final: seu pet volta pra casa limpinho e cheiroso.',
    art: illustration('perfume', 'Ilustração dos três personagens do logo limpinhos, com frasco de perfume', '50% 30%'),
  },
];

export const BATH_SIZES = [
  {
    id: 'pequeno',
    label: 'Pequeno',
    range: 'Até 10kg',
    maxKg: 10,
    photo: PHOTOS.salaoLacoLilas,
    rows: [
      { id: 'banho', label: 'Só banho', price: 40 },
      { id: 'higienica', label: 'Banho + Tosa higiênica', price: 55 },
      { id: 'completa', label: 'Banho + Tosa completa', price: 75, tag: 'Serviço premium' },
      { id: 'pacote', label: 'Pacote 4x', price: 160, note: 'Tosa higiênica incluída' },
    ],
  },
  {
    id: 'medio',
    label: 'Médio',
    range: '10kg a 25kg',
    maxKg: 25,
    photo: PHOTOS.posBanho,
    rows: [
      { id: 'banho', label: 'Só banho', price: 60 },
      { id: 'higienica', label: 'Banho + Tosa higiênica', price: 75 },
      { id: 'completa', label: 'Banho + Tosa completa', price: 95, tag: 'Serviço premium' },
      { id: 'pacote', label: 'Pacote 4x', price: 240, note: 'Tosa higiênica incluída' },
    ],
  },
  {
    id: 'grande',
    label: 'Grande',
    range: 'Acima de 25kg',
    maxKg: 60,
    photo: PHOTOS.salaoPastor,
    rows: [
      { id: 'banho', label: 'Só banho', price: 90 },
      { id: 'higienica', label: 'Banho + Tosa higiênica', price: null },
      { id: 'completa', label: 'Banho + Tosa completa', price: null },
      { id: 'pacote', label: 'Pacote 4x', price: 360 },
    ],
  },
];

export const WALK_PLANS = [
  { id: 'avulso', title: 'Avulso', detail: '1 hora', price: 20 },
  { id: 'semanal', title: 'Semanal', detail: '3x por semana', price: 55 },
  { id: 'mensal', title: 'Mensal', detail: '12 passeios', price: 170 },
];

export const FAQS = [
  {
    q: 'Como funciona o agendamento?',
    a: 'É só chamar a gente no WhatsApp! Combinamos o melhor dia e horário pra você e seu pet. Trabalhamos com agenda flexível durante a semana.',
  },
  {
    q: 'Quais portes vocês atendem?',
    a: 'Atendemos porte pequeno (até 10kg), médio (10kg a 25kg) e grande (acima de 25kg). Cada porte tem um valor específico para garantir o cuidado certo.',
  },
  {
    q: 'O que está incluso no banho?',
    a: 'Banho com produtos hipoalergênicos, secagem, escovação e perfume.',
  },
  {
    q: 'Como funciona o passeio?',
    a: 'Buscamos seu pet no local combinado e fazemos um passeio seguro de cerca de 1 hora. Temos planos avulso, semanal (3x) e mensal (12 passeios).',
  },
  {
    q: 'Onde vocês ficam?',
    a: 'Estamos em Jardim Alegre - PR. Para mais detalhes sobre localização, fale com a gente no WhatsApp.',
  },
];

// Galeria — legendas vêm das legendas/textos originais do site e do Instagram
// Fotos que passam no círculo do topo (hero): as mais fotográficas, feitas no salão.
// `pos` = onde fica o rosto (enquadramento) e `zoom` = aproximação dentro do círculo.
export const HERO_SLIDES = [
  { photo: PHOTOS.salaoLambendo, pos: '52% 36%', zoom: 1.35 },
  { photo: PHOTOS.salaoLacoLilas, pos: '50% 38%', zoom: 1.25 },
  { photo: PHOTOS.salaoPastor, pos: '50% 28%', zoom: 1.2 },
  { photo: PHOTOS.arraia, pos: '44% 30%', zoom: 1.2 },
  { photo: PHOTOS.salaoLacoVermelho, pos: '47% 40%', zoom: 1.25 },
  { photo: PHOTOS.noColo, pos: '44% 30%', zoom: 1.3 },
  { photo: PHOTOS.salaoDeitado, pos: '38% 52%', zoom: 1.35 },
];
export const HERO_PHOTO = HERO_SLIDES[0].photo;

// Homenagem à Lana — texto da homenagem feita pela Cãopanhia
export const LANA_TRIBUTE = {
  name: 'Lana',
  lines: [
    'Você chegou e deixou sua luz, seu amor e a sua doçura marcados para sempre no meu coração.',
    'Obrigada por cada momento, cada olhar e cada lambida.',
    'Você sempre será lembrada com',
    'muito carinho!',
    'Você foi muito mais que uma cliente, foi parte da minha história, dos meus dias e do meu coração.',
  ],
  farewell: ['Descanse em paz,', 'princesa.'],
};

export const GALLERY = [
  { ...PHOTOS.lana, caption: 'Lana 🌈', ratio: '3 / 4', memorial: true },
  { ...PHOTOS.salaoLacoLilas, caption: 'Maria-chiquinha com lacinhos lilás 💜', ratio: '3 / 4' },
  { ...PHOTOS.posBanho, caption: 'Fotinhas do pós-banho desse lindão 🧼🚿❤️🐶', ratio: '1 / 1' },
  { ...PHOTOS.salaoPastor, caption: 'Lacinhos cor-de-rosa 🎀', ratio: '3 / 4' },
  { ...PHOTOS.gatoLaranja, caption: 'Nenéns maravilhosos ❤️🤭', ratio: '1 / 1' },
  { ...PHOTOS.arraia, caption: 'Arraiá da Cãopanhia 🌽', ratio: '3 / 4' },
  {
    ...PHOTOS.yorkshireFofo,
    alt2: PHOTOS.yorkshireLingua.alt,
    lg2: PHOTOS.yorkshireLingua.lg,
    srcSet2: PHOTOS.yorkshireLingua.srcSet,
    caption: 'Yorkshire fofinho 😋',
    ratio: '3 / 4',
  },
  { ...PHOTOS.salaoLambendo, caption: 'Lambidinha no focinho 👅', ratio: '3 / 4' },
  { ...PHOTOS.siames, caption: 'Pet carinhoso 💙', ratio: '3 / 4' },
  { ...PHOTOS.salaoLacoVermelho, caption: 'Topete com laço vermelho ❤️', ratio: '3 / 4' },
  { ...PHOTOS.passeioBolinha, caption: 'Hora da bolinha 🎾', ratio: '9 / 16' },
  { ...PHOTOS.salaoDeitado, caption: 'Pose de modelo 📸', ratio: '3 / 4' },
  { ...PHOTOS.oculosEmPe, caption: 'Pet lindo 😎', ratio: '9 / 16' },
  { ...PHOTOS.lacoRosa, caption: 'Pet especial 🎀', ratio: '3 / 4' },
  { ...PHOTOS.passeioNoite, caption: 'Amigo peludo 🌙', ratio: '3 / 4' },
  { ...PHOTOS.noColo, caption: 'Carinhoso 🍓', ratio: '2 / 3' },
  { ...PHOTOS.grama, caption: 'Pet fofo 🌿', ratio: '1 / 1' },
  { ...PHOTOS.salaDeBanho, caption: 'Amiguinho feliz 🌈', ratio: '4 / 5' },
];

export const formatPrice = (value) => `R$${value}`;
